import { render, staticRenderFns } from "./ExploreScience.vue?vue&type=template&id=ea63ffa2&scoped=true&"
import script from "./ExploreScience.vue?vue&type=script&lang=js&"
export * from "./ExploreScience.vue?vue&type=script&lang=js&"
import style0 from "./ExploreScience.vue?vue&type=style&index=0&id=ea63ffa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea63ffa2",
  null
  
)

export default component.exports